module.exports = __webpack_public_path__ + "static/media/P25.4247f915.png";